import { useGetActiveDriverQuery } from '../services';
import { INDIVIDUAL_DRIVER_POLLING_INTERVAL } from '../config/pollingConfig';

export const useActiveDriver = (driverId: string) => {
  const { data, isLoading, error } = useGetActiveDriverQuery(driverId, {
    pollingInterval: INDIVIDUAL_DRIVER_POLLING_INTERVAL,
    skip: !driverId,
  });

  return {
    driver: data?.data,
    isLoading,
    error,
  };
};
